
const ConfigScreen = () => {
    return (
        <div></div>
    )
}
export default ConfigScreen;